import React from 'react'
import { useStyles } from './ConsumerGroupStyle'

export default function ConsumerGroup() {
    const style=useStyles()
    return (
        <div>
            <div className={style.consumertxt}>
                Consumer Groups
            </div>
            <div className={style.noConsumertxt}>
            No consumer Groups
            </div>
        </div>
    )
}
